import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux';
import './index.css'
import App from './App.tsx'
import store, { persistor } from './redux/store.ts'
import { PersistGate } from 'redux-persist/integration/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryScreen from '@components/ErrorBoundary';
import { Toaster } from "react-hot-toast";
import TagManager from 'react-gtm-module'

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GTM_ID
}

TagManager.initialize(tagManagerArgs)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (garbage collection time)
      refetchOnWindowFocus: false,
      refetchOnMount: true, 
      refetchOnReconnect: true, 
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ErrorBoundary FallbackComponent={ErrorBoundaryScreen}>
          <App />
          <Toaster toastOptions={{ duration: 5000 }} />
        </ErrorBoundary>
      </QueryClientProvider>
    </PersistGate>
  </Provider>
)
